// @ts-nocheck
import { useState } from "react"; 
import { useNavigate, useRevalidator, useRouteLoaderData } from "react-router-dom";
import { useUiStore } from "src/components/main/uiStore";
//-------------------------------------------------------------------------------------------------------------------
import { divisionList, tasks } from "src/components/outside/standby/standbyList";
import { useAuthStore } from "src/components/main/authStore";
import {
    outsideHolidays, 
    getDateEndFromWeekNum, 
    getDatefromWeekNum, 
    weekDays, 
    myAxios, 
    isMobilePhone, 
    numberReducer, 
    standbyReverseIndex as ri, 
    standbyCalculate as calc,
    standbyTP as tp} from "src/components/common/functions";
//-------------------------------------------------------------------------------------------------------------------
export default function StandByForm({ loaderId = "StandbyTimeCard" } = {}){
    const navigate = useNavigate();
    const revalidator = useRevalidator();
    const loaderData = useRouteLoaderData(loaderId) ?? {};
    const closeIt = () => navigate(loaderData?.basePath || `/StandbyTimeCard/${loaderData?.week || ""}`);
    const defaultData = loaderData?.form ?? {};
    const prevData = loaderData?.prevForm;
    const week = loaderData?.week;
    const selectedUser = loaderData?.selectedUser;
    const admin = loaderData?.admin === true;
    const user = useAuthStore(state => state.user);
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const roundup = (number, go) => {
        if(!go) return number;
        if(number === 0) return 0; 
        if(number <= 2) return 2;
        if(number <= 4) return 4;
        if(number <= 6) return 6;
        if(number <= 8) return 8;
    }
    const lessThan8 = (dayNum, jobNum) => {
        const overnight = (ri(getFirstJobStart(localData[dayNum])) + 96 - 
        (dayNum - 1 >= 0?
            ri(getLastJobEnd(localData[dayNum - 1]))
            :
            (localPrevData?
                (
                    getLastJobEnd(localPrevData[6])?
                    ri(getLastJobEnd(localPrevData[6]))
                    :
                    -Infinity
                )
                :
                -Infinity
            )
        )
        <= 32);
        const regularIndex = localData[dayNum].findIndex(job => job.category === "Rest" && (ri(job.end) - ri(job.start)) > 32);
        return overnight && (regularIndex === -1?true:(jobNum < regularIndex));
    };
    const getFirstJobStart = day => day.slice(1).find(job => ![
        "Hotel Charges 3rd Party", 
        "Hotel Charges PGE",
        "Toll Charges 3rd Party", 
        "Toll Charges PGE", 
        "Lunch", 
        "Rest"
    ].includes(job.category))?.start ?? "";
    const getLastJobEnd = day => (day).slice(1).findLast(job => ![
        "Hotel Charges 3rd Party", 
        "Hotel Charges PGE",
        "Toll Charges 3rd Party", 
        "Toll Charges PGE", 
        "Lunch", 
        "Rest"
    ].includes(job.category))?.end ?? "";
    //-------------------------------------------------------------------------------------------------------------------
    const [localData, setData] = useState(defaultData.data ?? Array(7).fill([{}]));
    const [localPrevData] = useState(prevData?.data ?? Array(7).fill([{}]));
    const [otherNotes, setOtherNotes] = useState(defaultData.otherNotes ?? "");
    const [region, setRegion] = useState(defaultData.region ?? "");
    //-------------------------------------------------------------------------------------------------------------------
    const curUser = selectedUser ?? user;
    const appendTargetUser = formData => {
        if(curUser?.id){
            formData.append("userId", curUser.id);
        }else if(curUser?.email){
            formData.append("userEmail", curUser.email);
        }
    }
    //-------------------------------------------------------------------------------------------------------------------
    const handleSave = async() => {
        const formData = new FormData();
        appendTargetUser(formData);
        formData.append("currentWeek", week);
        const data = [...localData];
        for(let i = 0; i < data.length; i++){
            delete data[i][0].s;
            delete data[i][0].o;
            delete data[i][0].t;
            delete data[i][0].bS;
            delete data[i][0].bO;
            delete data[i][0].bS2;
            delete data[i][0].bO2;
            delete data[i][0].bS3;
            delete data[i][0].bO3;
            delete data[i][0].bT;
            delete data[i][0].h;
            delete data[i][0].to;
            delete data[i][0].billableJobNumber;
            delete data[i][0].mobMileage;
            delete data[i][0].nbMileage;
            delete data[i][0].mileage;
            delete data[i][0].workMileage; // legacy
            delete data[i][0].lunch; // legacy
            data[i][0] = {};
            for(let j = 1; j < data[i].length; j++){
                delete data[i][j].startIndex;
                delete data[i][j].endIndex;
                delete data[i][j].ot;
                delete data[i][j].st;
                delete data[i][j].t;
                delete data[i][j].o;
                delete data[i][j].s;
                delete data[i][j].bO;
                delete data[i][j].bS;
                delete data[i][j].bO2;
                delete data[i][j].bS2;
                delete data[i][j].bO3;
                delete data[i][j].bS3;
                delete data[i][j].nb;
                delete data[i][j].bT;
            }
        }
        formData.append("data", JSON.stringify({
            data, 
            status: "Saved", 
            otherNotes,
            region,
            id: defaultData.id,
            billableId: defaultData.billableId
        }));
        formData.append("action", "save");
        //----------------------------
        setShowLoader(true);
        const res = await myAxios({ fileName: "outside/standby/updateTimeCard.php", formData: formData });
        setShowLoader(false);
        if(!res) return;
        //----------------------------
        revalidator.revalidate();
    }
    const handleSaveClose = async() => {
        await handleSave();
        closeIt();
    }
    const handleSubmit = async() => {
        if(!window.confirm("Are your sure to submit?")) return;
        const isOffWork = localData.every(day => day.length === 1);
        const isNBWork = localData.every(day => day.filter(job => ![
            "Rest", "Lunch", "Non Billable"
        ].includes(job.category)).length === 1);
        const formData = new FormData();
        if(!isOffWork){
            formData.append("timepicker", JSON.stringify(tp));
            //--------------------------------------------------------------------
            formData.append("userInfo", JSON.stringify(
                {
                    we: getDatefromWeekNum(week, 6),
                    weTitle: getDateEndFromWeekNum(week),
                    name: curUser.userName, 
                    phoneNumber: curUser.phoneNumber, 
                    lanId: curUser.lanId,
                    address: curUser.street || "N/A",
                    city: curUser.residence || "N/A",
                    stateZip: [curUser.residenceState, curUser.zipCode].filter(value => value).join(", ") || "N/A"
                }
            ));
            //--------------------------------------------------------------------
        }
        appendTargetUser(formData);
        formData.append("currentWeek", week);
        const data = [...localData];
        for(let i = 0; i < data.length; i++){
            delete data[i][0].s;
            delete data[i][0].o;
            delete data[i][0].t;
            delete data[i][0].bS;
            delete data[i][0].bO;
            delete data[i][0].bS2;
            delete data[i][0].bO2;
            delete data[i][0].bS3;
            delete data[i][0].bO3;
            delete data[i][0].bT;
            delete data[i][0].h;
            delete data[i][0].to;
            delete data[i][0].billableJobNumber;
            delete data[i][0].mobMileage;
            delete data[i][0].nbMileage;
            delete data[i][0].mileage;
            delete data[i][0].workMileage; // legacy
            delete data[i][0].lunch; // legacy
            data[i][0] = {};
            for(let j = 1; j < data[i].length; j++){
                delete data[i][j].startIndex;
                delete data[i][j].endIndex;
                delete data[i][j].ot;
                delete data[i][j].st;
                delete data[i][j].t;
                delete data[i][j].o;
                delete data[i][j].s;
                delete data[i][j].bO;
                delete data[i][j].bS;
                delete data[i][j].bO2;
                delete data[i][j].bS2;
                delete data[i][j].bO3;
                delete data[i][j].bS3;
                delete data[i][j].nb;
                delete data[i][j].bT;
            }
        }
        formData.append("data", JSON.stringify({
            data, 
            status: "Submitted", 
            otherNotes,
            region,
            id: defaultData.id,
            billableId: defaultData.billableId
        }));
        formData.append("action", "submit");
        formData.append("offWork", isOffWork?"yes":"no");
        formData.append("isNBWork", isNBWork?"yes":"no");
        //----------------------------
        setShowLoader(true);
        const res = await myAxios({ fileName: "outside/standby/updateTimeCard.php", formData: formData });
        setShowLoader(false);
        if(!res) return;
        //----------------------------
        revalidator.revalidate();
        closeIt();
    }
    const valueChange = (e, dayNum, jobNum, name) => {
        setData(localData.map((day, daynumber) => (
            dayNum === daynumber?
            day.map((job, jobnumber) => jobnumber === jobNum?{...job, 
                [name]: e.currentTarget.value
            }:job)
            :
            day
        )))
    }
    const getPrevJobEndIndex = (dayNum, jobNum) => {
        const jobs = localData[dayNum];
        for(let i = jobNum - 1; i > 0; i--){
            if(i > 0 && jobs[i].hotel !== "yes" && jobs[i].toll !== "yes") return ri(jobs[i].end);
        }
        const preJobs = dayNum !== 0?localData[dayNum - 1]:localPrevData[6];
        for(let i = preJobs.length - 1; i > 0; i--){
            if(i > 0 && preJobs[i].hotel !== "yes" && preJobs[i].toll !== "yes"){
                if(ri(preJobs[i].end) > 96){
                    return ri(preJobs[i].end) - 96;
                }
            }
        }
        return 0;
    }
    const getNextJobNum = (dayNum, jobNum) => {
        const jobs = localData[dayNum];
        for(let i = jobNum + 1; i < jobs.length; i++){
            if(i > 0 && jobs[i].hotel !== "yes" && jobs[i].toll !== "yes") return i;
        }
        return -1;
    }
    const getPrevJobNum = (dayNum, jobNum) => {
        const jobs = localData[dayNum];
        for(let i = jobNum - 1; i >= 0; i--){
            if(i > 0 && jobs[i].hotel !== "yes" && jobs[i].toll !== "yes") return i;
        }
        return -1;
    }
    const getFirstJobNum = (dayNum) => {
        const jobs = localData[dayNum];
        for(let i = 0; i < jobs.length; i++){
            if(i > 0 && jobs[i].hotel !== "yes" && jobs[i].toll !== "yes") return i;
        }
        return -1;
    }
    const isFirstJob = (dayNum, jobNum) => {
        return getFirstJobNum(dayNum) === jobNum;
    }
    // useEffect(() => {
    //     setOtherExpense(otherExpenses => otherExpenses.map(otherExpense => ({
    //         ...otherExpense,
    //         lineTotal: 
    //         otherExpense.expenseUnit && otherExpense.expenseRate?
    //         (Number(otherExpense.expenseUnit) * Number(otherExpense.expenseRate)).toFixed(2):
    //         ""
    //     })));
    // }, [calculateRenderSwitch])
    //-------------------------------------------------------------------------------------------------------------------
    return(
        <form
            onSubmit = {e => {
                e.preventDefault();
                handleSubmit();
            }}
        >
            {admin?
            <h1
                className = "px-3 pt-3"
            >
                <span className = "me-3" style = {{color: "purple"}}>{curUser.userName}</span>
            </h1>
            :null}
            <h1
                className = "px-3 pt-3"
                style = {{color: "purple"}}
            >
                <span className = "me-4">REGION</span>
                <select
                    className = "form-control h1 me-3 "
                    style = {{color: "purple"}}
                    value = {region}
                    onChange = {e => {
                        setRegion(e.currentTarget.value);
                    }}
                >
                    <option value = {""}>Select</option>
                    <option>SACRAMENTO</option>
                    <option>SOUTHERN</option>
                    <option>EAST BAY</option>
                    <option>BAY AREA</option>
                    <option>NORTH BAY</option>
                    <option>NORTHERN</option>
                    <option>CENTRAL</option>
                    <option>CENTRAL VALLEY</option>
                </select>
                <span className = "me-3 text-success">Weekly</span>
                <span className = "me-3 text-success">ST:{
                        localData.map((day, dayNum) => roundup(day.map((job, jobIndex) => ({...job, index: jobIndex})).filter(job => ![
                            "Lunch", 
                            "Rest", 
                            "Hotel Charges 3rd Party", 
                            "Hotel Charges PGE",
                            "Toll Charges 3rd Party", 
                            "Toll Charges PGE"
                        ].includes(job.category) && job.start && job.end).map(job => calc(ri(job.start), ri(job.end), dayNum >= 5 || outsideHolidays(Number(week.substring(1).split("-")[0])).map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(dayNum, job.index)).s).reduce(numberReducer, 0),
                        dayNum < 5
                    )).reduce(numberReducer, 0)}</span>
                    <span className = "me-3 text-success">OT: {
                        localData.map((day, dayNum) => roundup(day.map((job, jobIndex) => ({...job, index: jobIndex})).filter(job => ![
                            "Lunch", 
                            "Rest", 
                            "Hotel Charges 3rd Party", 
                            "Hotel Charges PGE",
                            "Toll Charges 3rd Party", 
                            "Toll Charges PGE"
                        ].includes(job.category) && job.start && job.end).map(job => calc(ri(job.start), ri(job.end), dayNum >= 5 || outsideHolidays(Number(week.substring(1).split("-")[0])).map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(dayNum, job.index)).o).reduce(numberReducer, 0),
                        dayNum >= 5
                    )).reduce(numberReducer, 0)}</span>
            </h1>
            {weekDays.map((dayName, dayNum) => 
            <div key = {dayNum}>
                <h1 className = "p-3">
                    <span className = "me-3">{dayName}</span>
                    <span className = "me-3">{week?`(${getDatefromWeekNum(week, dayNum)})`:null}</span>
                    <span className = "me-3 text-success">Daily</span>
                    <span className = "me-3 text-success">ST: {roundup(
                        localData[dayNum].map((job, jobIndex) => ({...job, index: jobIndex}))
                        .filter(job => ![
                            "Lunch", 
                            "Rest", 
                            "Hotel Charges 3rd Party", 
                            "Hotel Charges PGE",
                            "Toll Charges 3rd Party", 
                            "Toll Charges PGE"
                        ].includes(job.category) && job.start && job.end)
                        .map(job => calc(ri(job.start), ri(job.end), dayNum >= 5 || outsideHolidays(Number(week.substring(1).split("-")[0])).map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(dayNum, job.index)).s)
                        .reduce(numberReducer, 0)
                    )}</span>
                    <span className = "me-3 text-success">OT: {roundup(
                        localData[dayNum].map((job, jobIndex) => ({...job, index: jobIndex}))
                        .filter(job => ![
                            "Lunch", 
                            "Rest", 
                            "Hotel Charges 3rd Party", 
                            "Hotel Charges PGE", 
                            "Toll Charges 3rd Party", 
                            "Toll Charges PGE"
                        ].includes(job.category) && job.start && job.end).map(job => calc(ri(job.start), ri(job.end), dayNum >= 5 || outsideHolidays(Number(week.substring(1).split("-")[0])).map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(dayNum, job.index)).o).reduce(numberReducer, 0)
                    )}</span>
                </h1>

                {localData[dayNum].map((job, jobNum) => (
                <div className = "border rounded p-2 m-2" key = {jobNum}>
                    {jobNum === 0?
                    <></>
                    /*
                    <div className = "my-3">
                        <span className = "blk ms-3">
                                <span className = "me-3">On The Jobsite Mileage</span>
                                <input
                                    className = "me-3 form-control inline"
                                    style = {{maxWidth: 100}}
                                    type = "number"
                                    step = {1}
                                    min = {0}
                                    value = {job.workMileage ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "workMileage"
                                        );
                                    }}
                                />
                            </span>
                    </div>*/
                    :
                    <div className = {`mb-3${job.hotel === "yes" || job.toll === "yes"?" text-info":" text-success"}`}>
                        <div className = {`m-2`}>
                            <span className = {`blk`}>
                                <span
                                    className = {`me-3`}
                                >
                                    Task {jobNum}
                                </span>
                                <select
                                    className = {`me-3${
                                        isMobilePhone?
                                        ` w-auto`:
                                        ` form-control inline`
                                    }${job.hotel === "yes" || job.toll === "yes"?" text-info":" text-success"}`}
                                    type = "time"
                                    step = {900}
                                    required
                                    value = {job.category ?? ""}
                                    onChange = {e => {
                                        const value = e.currentTarget.value;
                                        const obj = {
                                            "category": value
                                        };
                                        if([
                                            "Hotel Charges 3rd Party", 
                                            "Hotel Charges PGE"
                                        ].includes(value)){
                                            obj.hotel = "yes";
                                        }else if([
                                            "Toll Charges 3rd Party", 
                                            "Toll Charges PGE"
                                        ].includes(value)){
                                            obj.toll = "yes";
                                        }else{
                                            const day = localData[dayNum];
                                            obj.start = day.length?(day[getPrevJobNum(dayNum, jobNum)]?.end ?? ""):"";
                                        }
                                        setData(localData.map((day, daynumber) => (
                                            dayNum === daynumber?
                                            day.map((job, jobnumber) => jobnumber === jobNum?obj:job)
                                            :
                                            day
                                        )));
                                    }}
                                >
                                    <option value = {""}>Select</option>
                                    {tasks.map((value, valueIndex) => 
                                    <option key = {valueIndex}>{value}</option>
                                    )}
                                </select>
                            </span>
                        </div>
                        {job.category !== ""?<>
                        {[
                            "Hotel Charges 3rd Party", 
                            "Hotel Charges PGE"
                        ].includes(job.category)?
                        <>
                        <div className = "m-2">
                            {["Hotel Charges PGE"].includes(job.category)?
                            <span className = "blk">
                                <span className = "me-3">PGE PM #</span>
                                <input
                                    type = "text"
                                    maxLength = {8}
                                    className = {`me-3 form-control inline${job.hotel === "yes"?" text-info":" text-success"}`}
                                    value = {job.pmNumber ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "pmNumber"
                                        );
                                    }}
                                />
                            </span>
                            :null}
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Division</span>
                                <select
                                    className = {`me-3 form-control inline${job.hotel === "yes"?" text-info":" text-success"}`}
                                    type = "text"
                                    value = {job.division ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "division"
                                        );
                                    }}
                                >
                                    <option value = "">Select</option>
                                    {divisionList.filter(item => item.range.includes(job.category)).map((item, valueIndex) => 
                                    <option key = {valueIndex}>{item.value}</option>
                                    )}
                                </select>
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Value($)</span>
                                <input
                                    className = {`me-3 form-control inline${job.hotel === "yes"?" text-info":" text-success"}`}
                                    style = {{maxWidth: 100}}
                                    type = "number"
                                    step = {0.01}
                                    min = {0}
                                    required
                                    value = {job.expenseValue ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "expenseValue"
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Description</span>
                                <input
                                    className = {`me-3 form-control inline${job.hotel === "yes"?" text-info":" text-success"}`}
                                    style = {{flexGrow: 1}}
                                    type = "text"
                                    required
                                    value = {job.description ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "description"
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        </>:null}
                        {[
                            "Toll Charges 3rd Party", 
                            "Toll Charges PGE"
                        ].includes(job.category)?
                        <>
                        <div className = "m-2">
                            {["Toll Charges PGE"].includes(job.category)?
                            <span className = "blk">
                                <span className = "me-3">PGE PM #</span>
                                <input
                                    type = "text"
                                    maxLength = {8}
                                    className = {`me-3 form-control inline${job.toll === "yes"?" text-info":" text-success"}`}
                                    value = {job.pmNumber ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "pmNumber"
                                        );
                                    }}
                                />
                            </span>
                            :null}
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Division</span>
                                <select
                                    className = {`me-3 form-control inline${job.toll === "yes"?" text-info":" text-success"}`}
                                    type = "text"
                                    value = {job.division ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "division"
                                        );
                                    }}
                                >
                                    <option value = "">Select</option>
                                    {divisionList.filter(item => item.range.includes(job.category)).map((item, valueIndex) => 
                                    <option key = {valueIndex}>{item.value}</option>
                                    )}
                                </select>
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Value($)</span>
                                <input
                                    className = {`me-3 form-control inline${job.toll === "yes"?" text-info":" text-success"}`}
                                    style = {{maxWidth: 100}}
                                    type = "number"
                                    step = {0.01}
                                    min = {0}
                                    required
                                    value = {job.expenseValue ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "expenseValue"
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Description</span>
                                <input
                                    className = {`me-3 form-control inline${job.toll === "yes"?" text-info":" text-success"}`}
                                    style = {{flexGrow: 1}}
                                    type = "text"
                                    required
                                    value = {job.description ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "description"
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        </>:null}
                        {[
                            "Mob 3rd Party", 
                            "Mob PGE", 
                            "DeMob 3rd Party", 
                            "DeMob PGE", 
                            "3rd Party Work", 
                            "PGE PM Work", 
                            "Rest", 
                            "Lunch",
                            "Non Production",
                            "Non Billable",
                        ].includes(job.category)?
                        <>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Start</span>
                                <select
                                    className = {`form-control me-3${job.hotel === "yes" || job.toll === "yes"?" text-info":" text-success"}`}
                                    required
                                    disabled = {!isFirstJob(dayNum, jobNum)}
                                    value = {job.start ?? ""}
                                    onChange = {e => {
                                        const target = e.currentTarget;
                                        const value = target.value;
                                        setData(localData.map((day, daynumber) => (
                                            dayNum === daynumber?
                                            day.map((job, jobnumber) => 
                                                jobnumber === jobNum?
                                                    {
                                                        ...job, 
                                                        "start": value
                                                    }
                                                    :
                                                    job
                                            )
                                            :
                                            day
                                        )));
                                    }}
                                >
                                    <option value = "">Select</option>
                                    {tp
                                    .filter((_, tIndex) => 
                                        tIndex >= getPrevJobEndIndex(dayNum, jobNum) && tIndex !== tp.length - 1
                                    ).map((t, i) => 
                                        <option key = {i} value = {t.value}>{t.text}</option>
                                    )}
                                </select>
                            </span>
                            <span className = "blk">
                                <span className = "me-3">End</span>
                                <select
                                    className = {`form-control me-3${job.hotel === "yes" || job.toll === "yes"?" text-info":" text-success"}`}
                                    required
                                    value = {job.end ?? ""}
                                    onChange = {e => {
                                        const target = e.currentTarget;
                                        const value = target.value;
                                        setData(localData.map((day, daynumber) => (
                                            dayNum === daynumber?
                                            day.map((job, jobnumber) => jobnumber === jobNum?{
                                                ...job, 
                                                "end": value
                                            }:((jobnumber === getNextJobNum(dayNum, jobNum)?
                                            {
                                                ...job, 
                                                "start": value
                                            }
                                            :job
                                        )))
                                            :
                                            day
                                        )));
                                    }}
                                >
                                    <option value = "">Select</option>
                                    {tp
                                    .filter(
                                        (_, tIndex) => 
                                        tIndex  > ri(job.start) && (dayNum === 6?tIndex <= 96:true)
                                    )
                                    .map((t, i) => 
                                        <option key = {i} value = {t.value}>{t.text}</option>
                                    )}
                                </select>
                            </span>
                        </div>
                        {[
                            "Mob PGE", 
                            "DeMob PGE", 
                            "PGE PM Work", 
                        ].includes(job.category)?
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">PGE PM #</span>
                                <input
                                    type = "text"
                                    maxLength = {8}
                                    required
                                    className = {`me-3 form-control inline${job.hotel === "yes" || job.toll === "yes"?" text-info":" text-success"}`}
                                    value = {job.pmNumber ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "pmNumber"
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        :null}
                        {!["Rest", "Lunch", "Non Billable"].includes(job.category)?
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Division</span>
                                <select
                                    className = {`me-3 form-control inline${job.hotel === "yes" || job.toll === "yes"?" text-info":" text-success"}`}
                                    type = "text"
                                    required
                                    value = {job.division ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "division"
                                        );
                                    }}
                                >
                                    <option value = "">Select</option>
                                    {divisionList.filter(item => item.range.includes(job.category)).map((item, valueIndex) => 
                                    <option key = {valueIndex}>{item.value}</option>
                                    )}
                                </select>
                            </span>
                        </div>
                        :<></>}
                        {["Mob PGE", "Mob 3rd Party", "DeMob 3rd Party", "DeMob PGE", "Non Production"].includes(job.category)?
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Mileage</span>
                                <input
                                    className = {`me-3 form-control inline${job.hotel === "yes" || job.toll === "yes"?" text-info":" text-success"}`}
                                    style = {{maxWidth: 100}}
                                    type = "number"
                                    step = {1}
                                    min = {0}
                                    required
                                    value = {job.mobMileage ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "mobMileage"
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        :null}
                        {["Non Billable"].includes(job.category)?
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Mileage</span>
                                <input
                                    className = {`me-3 form-control inline${job.hotel === "yes" || job.toll === "yes"?" text-info":" text-success"}`}
                                    style = {{maxWidth: 100}}
                                    type = "number"
                                    step = {1}
                                    min = {0}
                                    required
                                    value = {job.nbMileage ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "nbMileage"
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        :null}
                        {!["Rest", "Lunch"].includes(job.category)?<>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Description</span>
                                <input
                                    className = {`me-3 form-control inline${job.hotel === "yes" || job.toll === "yes"?" text-info":" text-success"}`}
                                    type = "text"
                                    value = {job.description ?? ""}
                                    onChange = {e => {
                                        valueChange(
                                            e, dayNum, jobNum, "description"
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        {job.start && job.end?
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">ST</span>
                                <input
                                    type = "text"
                                    className = "form-control text-center me-3"
                                    style = {{width: 80}}
                                    disabled
                                    value = {calc(ri(job.start), ri(job.end), dayNum >= 5 || outsideHolidays(Number(week.substring(1).split("-")[0])).map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(dayNum, jobNum)).s}
                                />
                            </span>
                            <span className = "blk">
                                <span className = "me-3">OT</span>
                                <input
                                    type = "text"
                                    className = "form-control text-center me-3"
                                    style = {{width: 80}}
                                    disabled
                                    value = {calc(ri(job.start), ri(job.end), dayNum >= 5 || outsideHolidays(Number(week.substring(1).split("-")[0])).map(h => h.date).includes(getDatefromWeekNum(week, dayNum)) || lessThan8(dayNum, jobNum)).o}
                                />
                            </span>
                        </div>
                        :<></>}
                        </>
                        :<></>}
                        </>:null}
                        </>:null}
                    </div>
                    }
                    <div className = "mb-3">
                        <span className = "btn btn-success m-3" 
                            onClick = {() => {
                                setData(localData.map((day, daynumber) => (
                                    dayNum === daynumber?
                                    [...day.slice(0, jobNum + 1), {
                                        category: ""
                                    }, ...day.slice(jobNum + 1)]
                                    :
                                    day
                                )))
                            }}
                        >
                            Add Task Below
                        </span>
                        {jobNum !== 0?
                        <span
                            className = "btn btn-danger mx-3"
                            onClick = {() => {
                                setData(
                                    localData.map((day, daynumber) => (
                                    daynumber === dayNum? 
                                    day.map(
                                        (j, jobnumber) => 
                                        jobnumber === getNextJobNum(dayNum, jobNum)?
                                        ({
                                            ...j, 
                                            "start": day[getPrevJobNum(dayNum, jobNum)]?.end ?? ""
                                        })
                                        :
                                        j
                                    )
                                    .filter((j, jobnumber) => (jobNum !== jobnumber))
                                    :
                                    day))
                                );
                            }}
                        >
                            Delete
                        </span>:null}
                        {false?
                        <span
                            className = "btn btn-info mx-3"
                            onClick = {handleSave}
                        >
                            Save
                        </span>
                        :null}
                    </div>
                </div>
                ))}
            </div>
            )}
            {/*
            <div>
                <h1 className = "p-3">Other Expenses ${otherExpenses.map(expense => Number(expense.lineTotal || 0)).reduce(numberReducer, 0).toFixed(2)}</h1>
                {otherExpenses.map((otherExpense, jobNum) => (
                <div className = "border rounded p-2 m-2" key = {jobNum}>
                    <div className = "mb-3">
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Date</span>
                                <input
                                    className = "me-3 form-control inline"
                                    type = "date"
                                    min = {getDatefromWeekNum(week, 0)}
                                    max = {getDatefromWeekNum(week, 6)}
                                    required
                                    value = {otherExpense.expenseDate ?? ""}
                                    onChange = {e => {
                                        setOtherExpense(
                                            otherExpenses.map((otherExpense, jobnumber) => jobnumber === jobNum?
                                            {
                                                ...otherExpense, 
                                                "expenseDate": e.currentTarget.value
                                            }:otherExpense)
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Type</span>
                                <input
                                    className = "me-3 form-control inline"
                                    style = {{maxWidth: 100}}
                                    type = "text"
                                    required
                                    value = {otherExpense.expenseType ?? ""}
                                    onChange = {e => {
                                        setOtherExpense(
                                            otherExpenses.map((otherExpense, jobnumber) => jobnumber === jobNum?
                                            {
                                                ...otherExpense, 
                                                "expenseType": e.currentTarget.value
                                            }:otherExpense)
                                        );
                                    }}
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Unit</span>
                                <input
                                    className = "me-3 form-control inline"
                                    style = {{maxWidth: 100}}
                                    type = "number"
                                    step = {0.01}
                                    min = {0}
                                    required
                                    value = {otherExpense.expenseUnit ?? ""}
                                    onChange = {e => {
                                        setOtherExpense(
                                            otherExpenses.map((otherExpense, jobnumber) => jobnumber === jobNum?
                                            {
                                                ...otherExpense, 
                                                "expenseUnit": e.currentTarget.value
                                            }:otherExpense)
                                        );
                                        setCalculateRenderSwitch(s => !s);
                                    }}
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Rate($)</span>
                                <input
                                    className = "me-3 form-control inline"
                                    style = {{maxWidth: 100}}
                                    type = "number"
                                    step = {0.01}
                                    min = {0}
                                    required
                                    value = {otherExpense.expenseRate ?? ""}
                                    onChange = {e => {
                                        setOtherExpense(
                                            otherExpenses.map((otherExpense, jobnumber) => jobnumber === jobNum?
                                            {
                                                ...otherExpense, 
                                                "expenseRate": e.currentTarget.value
                                            }:otherExpense)
                                        );
                                        setCalculateRenderSwitch(s => !s);
                                    }}
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "me-3">Line Toal($)</span>
                                <input
                                    disabled
                                    className = "me-3 form-control inline"
                                    style = {{maxWidth: 100}}
                                    value = {otherExpense.lineTotal ?? ""}
                                />
                            </span>
                        </div>
                    </div>
                    <div className = "mb-3">
                        <span
                            className = "btn btn-danger mx-3"
                            onClick = {() => {
                            setOtherExpense(
                                otherExpenses.filter((otherExpense, jobnumber) => (jobNum !== jobnumber))
                            );
                        }}>
                            Delete
                        </span>
                        {false?
                        <span
                            className = "btn btn-info mx-3"
                            onClick = {handleSave}
                        >
                            Save
                        </span>
                        :null}
                    </div>
                </div>
                ))}
                <span className = "btn btn-success m-3" 
                    onClick = {() => {
                        setOtherExpense(
                            [...otherExpenses, {}]
                        );
                    }}
                >
                    Add Other Expense
                </span>
            </div>
            */}

            <div className = "m-2 p-2">
                <label className = "h1 p-3">Other Notes</label>
                <textarea
                    rows = {8}
                    className = "form-control"
                    style = {{width: "100%"}}
                    value = {otherNotes}
                    onChange = {e => {
                        setOtherNotes(e.currentTarget.value);
                    }}
                />
            </div>
            <div className = "d-flex flex-wrap justify-content-end gap-2 px-3 py-3 border-top">
                <button
                    type = "button"
                    className = "btn btn-outline-secondary"
                    onClick = {closeIt}
                >
                    Close
                </button>
                <button
                    type = "button"
                    className = "btn btn-outline-primary"
                    onClick = {handleSaveClose}
                >
                    Save & Close
                </button>
                <button
                    type = "submit"
                    className = "btn btn-primary"
                >
                    Submit
                </button>
            </div>
        </form>
    )
}
